import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Button } from '@naf-simba/elements-buttons';

export const VehicleAlertsWrapper = styled.div`
  margin-top: auto;
  padding-top: ${spacing.space16};
`;

export const BookToday = styled(Typography)`
  && {
    margin: 0 0 ${spacing.space16};
    font-weight: 900;
  }
`;

export const BookEarly = styled(Typography)`
  && {
    margin: 0 0 ${spacing.space16};
  }
`;

export const PriceBlock = styled.div`
  margin-bottom: ${spacing.space16};

  h5,
  p {
    margin: 0;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: ${spacing.space20};
`;
